import { enumKeyboardTargetEnterAction } from "../constants";

export function PTabToNextElement(curTargetElement, panel, shiftOff, textEditList, wsMgr) {
  if (curTargetElement) {
    var n = textEditList.length;
    var curIndex = textEditList.indexOf(curTargetElement);
    var curTabID = curTargetElement.GetTabID();
    var nextElement = panel.GetFirstAvailableTextEdit(
      textEditList,
      curIndex,
      curTabID,
      n,
      shiftOff
    );
    if (nextElement != curTargetElement) {
      wsMgr.SetKeyboardTarget(nextElement, panel, enumKeyboardTargetEnterAction.selectAll);
      var tabControlPanel = null;

      if (nextElement.fTabControlPanel) tabControlPanel = nextElement.fTabControlPanel;
      else if (panel != nextElement.fParentPanel) tabControlPanel = panel;

      if (tabControlPanel != null) tabControlPanel.PanToNextElement(nextElement);
    }
  }
}
